export default __webpack_public_path__ + "static/media/9f787a64850595b39faf71be2e78c908.svg";